import { type AggregationFn } from "@tanstack/react-table";

import { isComparableNumber, round } from "./aggregationFnUtils";

export const min: AggregationFn<unknown> = (columnId, leafRows, _immediateChildRows) => {
	let min: number | undefined;

	// NOTE: If we ever support nested columns, we might want to `min` the `immediateChildRows` of
	// this grouping, since they'll have aggregated their own children.
	leafRows.forEach((row) => {
		const value = row.getValue(columnId);

		if (isComparableNumber(value) && (min === undefined || min > value)) {
			min = value;
		}
	});

	if (min === undefined) {
		return null;
	}

	return round(min);
};
